import React from 'react';
import styled from "styled-components";
import SigBusket from "../../components/alerts/inventoryManagementAlerts/SigBusket";
import PageTitle from "../../components/PageTitle";
import Icn from "../../components/Icn";
import Tx from "../../components/Tx";

const WrapperStyled = styled.div`
    display: grid;
`;

const SigmaBusketPage = () => {
    return (
        <div style={{height: '100%', padding: 20, overflow: 'auto'}}>
            <PageTitle>
                <div style={{position: 'relative'}}>
                    <Icn>priorityHighIcon</Icn> <Tx>menu.sigBusket</Tx>
                </div>
            </PageTitle>
            <WrapperStyled>
                <SigBusket/>
            </WrapperStyled>
        </div>
    );
};

export default SigmaBusketPage;